import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";

export default class Files {

  generateUploadToken = async (body: AuthBodyType, amount: number, path: string) => {
    try {
      const data = await api.post("/files/generateUploadToken", {
        ...body,
        amount,
        path,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  uploadFilesV2 = async (data: FormData, token: string) => {
    try {
      const response = await api.post("/files/uploadFilesV2", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-uftoken": token,
        },
      });
      return response;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        throw new Error(error.message);
      }
    }
  };

  // uploadFiles = async (formData: FormData) => {
  //   try {
  //     const data: AxiosResponse = await this.api.post("/uploadFiles", formData, { headers: { "Content-Type": "multipart/form-data" } });
  //     return data.data;
  //   } catch (err) {
  //     const error = err as Error | AxiosError;
  //     if (axios.isAxiosError(error)) {
  //       console.error(error.message);
  //       return error.response?.status;
  //     }
  //   }
  // };

  downloadFiles = async (body: AuthBodyType, platform: string, version: string, paths: string[]) => {
    try {
      const data: AxiosResponse = await api.post("/files/downloadFiles", {
        ...body,
        platform,
        version,
        paths,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        return error.response?.status;
      }
    }
  };
}
